// src/contexts/DarkModeContext.js

import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { usePreferences } from './PreferencesContext';

const DarkModeContext = createContext(undefined);

export const useDarkMode = () => {
    const context = useContext(DarkModeContext);
    if (!context) {
        throw new Error('useDarkMode must be used within a DarkModeProvider');
    }
    return context;

}
export const DarkModeProvider = ({ children }) => {
    const { preferences, updatePreference, loaded } = usePreferences();
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const storedMode = localStorage.getItem('darkMode');
        return storedMode !== null ? JSON.parse(storedMode) : true;
    });
    const serverSynced = useRef(false);

    // Sync from server preferences once loaded
    useEffect(() => {
        if (loaded && !serverSynced.current && preferences.darkMode !== undefined) {
            serverSynced.current = true;
            setIsDarkMode(preferences.darkMode);
        }
    }, [loaded, preferences.darkMode]);

    useEffect(() => {
        document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    }, [isDarkMode]);

    const toggleDarkMode = () => {
        const newValue = !isDarkMode;
        setIsDarkMode(newValue);
        updatePreference('darkMode', newValue);
    };

    return (
        <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
};


export default DarkModeContext;
